import { render } from "./anc_visits.vue?vue&type=template&id=cc5fc5e6&scoped=true"
import script from "./anc_visits.vue?vue&type=script&lang=js"
export * from "./anc_visits.vue?vue&type=script&lang=js"

import "./anc_visits.vue?vue&type=style&index=0&id=cc5fc5e6&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc5fc5e6"]])

export default __exports__